import { render, staticRenderFns } from "./AppHypotheekgevers.vue?vue&type=template&id=5ba3e622&scoped=true&"
import script from "./AppHypotheekgevers.ts?vue&type=script&lang=ts&"
export * from "./AppHypotheekgevers.ts?vue&type=script&lang=ts&"
import style0 from "./AppHypotheekgevers.scss?vue&type=style&index=0&id=5ba3e622&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba3e622",
  null
  
)

export default component.exports